import { DevicePid, KK } from "@/define/define";
import { JingTaiMer68Devices } from "@/define/device_vendor";
import { DeviceManager } from "@/service/device";
import { GetMagnetKeyInfo, PostMagnetSetKeyInfo } from "@/service/driver/magnet_set";
import { STORAGE_KEYS } from "@libs/define/storage_key";

/**
 * 问题设备：mer68/mer68pro/polar75
 * 问题：设置低于0.005行程后，拔插设备会出现默认值问题，黄条是2.0 蓝/绿 是0.3
 * 解决方案：用户设置低于0.005，存到localStorage中,实际设置是0.005,显示时还原用户设置
 *
*/
const localKey = STORAGE_KEYS.JingTaiMer68Traveler

const requiresTravelAdjustment = (): boolean => {
    const currentPid = DeviceManager.instance.state.currentPid;
    return [...JingTaiMer68Devices, DevicePid.IYXPolar75].includes(currentPid);
}
export const adjustTravel = (data: PostMagnetSetKeyInfo): PostMagnetSetKeyInfo => {
    if (!requiresTravelAdjustment()) return { ...data };
    const modifiedData = { ...data };

    const localData = localStorage.getItem(localKey);
    const storedSettings: Record<string, GetMagnetKeyInfo> = localData ? JSON.parse(localData) : {};

    modifiedData.Keys.forEach((element) => {
        const local_item = storedSettings[element] || {} as GetMagnetKeyInfo;
        if (modifiedData.PressNum < 5 && modifiedData.PressNum != 0) {
            modifiedData.PressNum = 5;
        }
        if (modifiedData.ReleaseNum < 5 && modifiedData.ReleaseNum != 0) {
            modifiedData.ReleaseNum = 5;
        }
        if (modifiedData.QuickTriggerPressNum < 5 && modifiedData.QuickTriggerPressNum != 0) {
            modifiedData.QuickTriggerPressNum = 5;
        }
        if (modifiedData.QuickTriggerReleaseNum < 5 && modifiedData.QuickTriggerReleaseNum != 0) {
            modifiedData.QuickTriggerReleaseNum = 5;
        }
        local_item.ReleaseNum = data.ReleaseNum;
        local_item.PressNum = data.PressNum;
        local_item.QuickTriggerPressNum = data.QuickTriggerPressNum;
        local_item.QuickTriggerReleaseNum = data.QuickTriggerReleaseNum;

        if (local_item.PressNum >= 5
            && local_item.ReleaseNum >= 5
            && local_item.QuickTriggerPressNum >= 5
            && local_item.QuickTriggerReleaseNum >= 5
            && storedSettings[element]) {
            delete storedSettings[element];
        } else {
            storedSettings[element] = local_item;
        }
    })
    localStorage.setItem(localKey, JSON.stringify(storedSettings));
    return { ...modifiedData };
}

export const handleGetTravel = (res: GetMagnetKeyInfo[]): GetMagnetKeyInfo[] => {
    if (!requiresTravelAdjustment()) return [...res];
    const localData = localStorage.getItem(localKey);
    if (localData == null) return [...res];
    const infoMap = JSON.parse(localData) as { [index: KK]: GetMagnetKeyInfo };
    const modifiedData = [...res];
    modifiedData.map((item) => {
        const local_item = infoMap[item.Key];
        if (local_item) {
            if (local_item.PressNum && local_item.PressNum < 5 && item.PressNum == 5) {
                item.PressNum = local_item.PressNum;
            }
            if (local_item.ReleaseNum && local_item.ReleaseNum < 5 && item.ReleaseNum == 5) {
                item.ReleaseNum = local_item.ReleaseNum;
            }
            if (local_item.QuickTriggerPressNum && local_item.QuickTriggerPressNum < 5 && item.QuickTriggerPressNum == 5) {
                item.QuickTriggerPressNum = local_item.QuickTriggerPressNum;
            }
            if (local_item.QuickTriggerReleaseNum && local_item.QuickTriggerReleaseNum < 5 && item.QuickTriggerReleaseNum == 5) {
                item.QuickTriggerReleaseNum = local_item.QuickTriggerReleaseNum;
            }
        }
    })
    return [...modifiedData]
}
// 清除缓存
export const clearAdjustTravelStorage = () => {
    localStorage.removeItem(localKey);
}
